import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-pac-view',
  templateUrl: './pac-view.component.html',
  styleUrls: ['./pac-view.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class PacViewComponent {

  constructor() { }

  @Output('back') back: EventEmitter<any> = new EventEmitter();

  toBack() {
    this.back.next(true);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/terms-of-use/pac-view/pac-view.component.ts